import type { Translations } from '../../../types'

const shopVariantsCardMessages: Translations = {
  "shop.variantsCard.title": "Varianti",
  "shop.variantsCard.empty": "Nessuna variante aggiunta.",
  "shop.variantsCard.fields.categories": "Categorie:",
  "shop.variantsCard.fields.noCategory": "Nessuna",
  "shop.variantsCard.fields.sku": "SKU:",
  "shop.variantsCard.fields.stock": "Stock:",
  "shop.variantsCard.fields.overrides": "Override:",
  "shop.variantsCard.fields.price": "Prezzo:",
  "shop.variantsCard.fields.quantity": "Quantita:",
  "shop.variantsCard.actions.add": "+ Aggiungi variante",
  "shop.variantsCard.actions.photo": "Foto",
  "shop.variantsCard.actions.edit": "Modifica",
  "shop.variantsCard.actions.remove": "Rimuovi",
}

export default shopVariantsCardMessages
